export default "__VITE_ASSET__BLTP80tf__"